import { AppointmentStatus } from '@lingoda/monolith-graphql';
import type { BookableClass } from '@lingoda/booking';
import type { Theme } from '@lingoda/ui';
import { trans } from '@lingoda/i18n';
import { colorsPalette } from '@lingoda/ui/theme';
import { XIcon } from '@lingoda/ui/icons/lingodaIcons';

export const getAppointmentStatusIcon = (status: AppointmentStatus) =>
    [AppointmentStatus.Active, AppointmentStatus.Attended].includes(status) ? null : (
        <XIcon size={16} />
    );

export const getAppointmentStatusText = (
    status: AppointmentStatus,
    isPast: boolean,
    isUpcoming: boolean,
): string | undefined => {
    switch (status) {
        case AppointmentStatus.Deleted:
            return trans('cancelled', {}, 'student-common').toUpperCase();
        case AppointmentStatus.Cancelled:
            return trans('cancelled', {}, 'student-common').toUpperCase();
        case AppointmentStatus.Active:
            if (isPast) {
                return undefined;
            }

            return isUpcoming
                ? trans('upcoming', {}, 'student-common').toUpperCase()
                : `${trans('you-are-joining-this-class', {}, 'student-common')} 🎉`;
        case AppointmentStatus.Attended:
            return undefined;
        case AppointmentStatus.Missed:
            return trans('missed', {}, 'student-common').toUpperCase();
        default:
            return undefined;
    }
};

export const getAppointmentStatusColor = (
    theme: Theme,
    status: AppointmentStatus,
    isFutureUpcoming: boolean,
) => {
    if (isFutureUpcoming) {
        return colorsPalette.purpleSolid[100];
    }

    switch (status) {
        case AppointmentStatus.Active:
            return theme.colors.text.success;
        case AppointmentStatus.Attended:
            return colorsPalette.purpleSolid[100];
        case AppointmentStatus.Cancelled:
            return 'text.secondary';
        case AppointmentStatus.Deleted:
        case AppointmentStatus.Missed:
            return theme.colors.text.danger;
    }
};

export const getStudentAvatarsFromClass = (klass: BookableClass) =>
    klass.students.map((student) => ({
        firstName: student.shortName,
        src: student.photo?.urls.medium,
        id: student.id,
    }));
